import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { getColorScheme } from '../../colors';
var menuDividerStyles = {
  root: function root(_ref) {
    var p = _ref.props,
        v = _ref.variables;
    var colors = getColorScheme(v.colorScheme, null, p.primary);
    var borderColor = p.primary ? v.primaryBorderColor : v.borderColor || colors.border;
    var borderType = p.vertical ? 'borderTop' : 'borderLeft';
    return p.content ? {
      display: 'flex',
      justifyContent: 'center',
      flexDirection: 'column',
      textAlign: 'center'
    } : Object.assign(_defineProperty({}, borderType, "1px solid ".concat(borderColor)), !p.vertical && {
      alignSelf: 'stretch'
    }, {}, p.vertical && p.inSubmenu && {
      margin: '8px 0'
    });
  }
};
export default menuDividerStyles;